// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"]},{\"path\":\"/:locale/start-interview\",\"regex\":\"^/([^/]+)/start-interview$\",\"paramNames\":[\"locale\"]}],\"staticRoutes\":[{\"path\":\"/feedback\"},{\"path\":\"/next-steps\"},{\"path\":\"/redirect-user\"}]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://28b4a31d9918dd9d2fb09b34ab4ebf42@o4510007685021696.ingest.de.sentry.io/4510007692034128",

  // Performance Monitoring
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0, // 10% in production, 100% in development

  // Session Replay
  replaysSessionSampleRate: 0.1, // 10% of sessions will be replayed
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors will be replayed

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: process.env.NODE_ENV === "development",

  // Process events before sending
  beforeSend(event, hint) {
    // Filter out events that might contain sensitive data
    if (event.request?.cookies) {
      delete event.request.cookies;
    }

    // Add interview context if available
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const companyId = searchParams.get("companyId");
      const candidateId = searchParams.get("userId");

      if (companyId || candidateId) {
        event.tags = {
          ...event.tags,
          has_company_id: !!companyId,
          has_candidate_id: !!candidateId,
        };
      }
    }

    // Filter out non-critical errors in production
    if (process.env.NODE_ENV === "production") {
      const error = hint.originalException;

      // Filter out network errors that are expected
      if (error instanceof Error) {
        // Filter out ad blocker related errors
        if (
          error.message?.includes("Ad blocker") ||
          error.message?.includes("uBlock") ||
          error.message?.includes("AdGuard")
        ) {
          return null;
        }

        // Filter out browser extension errors
        if (
          error.stack?.includes("chrome-extension://") ||
          error.stack?.includes("moz-extension://")
        ) {
          return null;
        }

        // Filter out ResizeObserver errors (usually benign)
        if (error.message?.includes("ResizeObserver loop limit exceeded")) {
          return null;
        }
      }
    }

    return event;
  },

  // Ignore certain errors
  ignoreErrors: [
    // Browser extensions
    "top.GLOBALS",
    // Facebook related errors
    "fb_xd_fragment",
    // Network errors that are usually not actionable
    "Network request failed",
    "NetworkError",
    "Failed to fetch",
    // Safari specific errors
    "Non-Error promise rejection captured",
    // Chrome specific
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
  ],

  // Configure allowed URLs for error capturing
  // allowUrls: [/https:\/\/.*\.hirevoice\.ai/, /http:\/\/localhost:\d+/],
  allowUrls: ["*"], // For now this is ok

  // Environment
  environment: process.env.NODE_ENV || "production",

  // Additional options
  sendClientReports: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
